import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  Container,
  useColorMode,
} from "@chakra-ui/react";
import { getCurrentColor } from "../../constants";

const ShotShowHeroSection = () => {
  const { colorMode } = useColorMode();

  const scrollToHowItWorks = () => {
    const element = document.getElementById("how-it-works");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box
      bg={getCurrentColor(colorMode, "whiteC.200", "blueC.500")}
      py={{ base: "20px", md: "30px", lg: "50px" }}
    >
      <Container maxW="7xl">
        <Flex align="start" gap={{ base: 8, md: 12 }}>
          <Box flex={1} minW={0}>
            <Heading
              as="h1"
              fontSize={{ base: "48px", sm: "60px", md: "72px", lg: "96px" }}
              fontWeight="900"
              color={getCurrentColor(colorMode, "blackC.100", "whiteC.200")}
              mb={8}
              lineHeight="1.1"
              letterSpacing="tight"
            >
              A Better Way to Search for Ammo
            </Heading>

            <Text
              fontSize={{ base: "lg", md: "2xl" }}
              color={"blueC.100"}
              mb={6}
              fontWeight="600"
              lineHeight="relaxed"
              maxW="3xl"
            >
              BulletScout shows the true shipped cost per round to your ZIP — so
              you don't waste time bouncing between sites or getting surprised
              at checkout.
            </Text>

            <Text
              fontSize={{ base: "md", md: "lg" }}
              color={getCurrentColor(colorMode, "blackC.100", "whiteC.200")}
              mb={6}
              lineHeight="relaxed"
              maxW="3xl"
            >
              Buying ammo online shouldn't require opening ten tabs, guessing
              shipping costs, or getting burned at checkout. BulletScout is a
              free ammo price comparison search engine built for shooters who
              want to see the real, delivered cost per round before they buy.
            </Text>

            <Text
              fontSize={{ base: "sm", md: "md" }}
              color={getCurrentColor(colorMode, "grayC.300", "grayC.700")}
              mb={12}
              maxW="2xl"
              lineHeight="relaxed"
            >
              100% free. No signup. No email.
            </Text>

            <Flex direction={{ base: "column", sm: "row" }} gap={4}>
              <Button
                as="a"
                href="/"
                bg={"blueC.100"}
                color={"whiteC.100"}
                px={8}
                py={7}
                borderRadius="lg"
                fontWeight="700"
                fontSize="lg"
                _hover={{ bg: "blueC.400" }}
                transition="all 0.2s"
              >
                Search Ammo Prices Now
              </Button>
              <Button
                onClick={scrollToHowItWorks}
                variant="outline"
                borderWidth="2px"
                borderColor={getCurrentColor(
                  colorMode,
                  "grayC.500",
                  "grayC.2000"
                )}
                color={getCurrentColor(colorMode, "blackC.100", "whiteC.200")}
                px={8}
                py={7}
                borderRadius="lg"
                fontWeight="700"
                fontSize="lg"
                _hover={{
                  borderColor: "blueC.100",
                  bg: getCurrentColor(colorMode, "grayC.600", "grayC.1700"),
                }}
                transition="all 0.2s"
              >
                See How It Works
              </Button>
            </Flex>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

export default ShotShowHeroSection;